<template>
  <v-card style="padding:20px 35px">
    <v-card-title class="headline">
      {{ headerText }}
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-textarea
          v-model="reasonText"
          name="input-1"
          label="理由を入力してください。（例：入電により）"
          outline
        />
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="warning"
        @click="$emit('toggle-dialog')"
      >
        キャンセル
      </v-btn>
      <v-btn
        color="success"
        @click="$emit('date-update', reasonText)"
      >
        保存
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      reasonText: ''
    }
  },
  computed: {
    headerText () {
      let arr = this.date.split('-')
      return `${arr[0]}年${arr[1]}月${arr[2]}日に配送指定します`
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .v-dialog:not(.v-dialog--fullscreen){
  border-radius: 7px;
}
</style>
